module.exports = __webpack_public_path__ + "static/vue-block-tree-b3a3b7b18e28a7033a1a5709d11b3dd9.png";